import React from 'react';
import {
  FaTachometerAlt,
  FaHistory,
  FaInfoCircle,
  FaTicketAlt,
  FaCalendarCheck,
  FaPlaceOfWorship,
  FaBuilding,
  FaCalendarAlt,
  FaTasks,
  FaBoxOpen,
  FaBullhorn,
  FaClipboardList,
} from 'react-icons/fa';

const TabNavigation = ({ currentTab, setCurrentTab, entityType }) => {
  // Define tab configurations for each entity type
  const tabConfig = {
    venue: [
      { key: 'dashboard', label: 'Dashboard', icon: FaTachometerAlt },
      { key: 'orderHistory', label: 'Order History', icon: FaHistory },
      { key:'productUpdation', label:'Product Details', icon: FaBoxOpen},
      { key: 'slotManagement', label: 'Slot Management', icon: FaCalendarAlt },
      { key:'promotions', label: 'Promotions', icon: FaBullhorn},
      { key: 'venueDetails', label: 'Venue Details', icon: FaPlaceOfWorship },
      { key: 'about', label: 'About', icon: FaInfoCircle },
    ],
    event: [
      { key: 'dashboard', label: 'Dashboard', icon: FaTachometerAlt },
      { key: 'orderHistory', label: 'Order History', icon: FaHistory },
      { key: 'eventInfo', label: 'Event Information', icon: FaCalendarCheck },
      { key: 'subevents', label: 'Subevents', icon: FaTasks },
      { key: 'orgInfo', label: 'Organization Info', icon: FaBuilding },
      { key: 'about', label: 'About', icon: FaInfoCircle },
    ],
    temple: [
      { key: 'dashboard', label: 'Dashboard', icon: FaTachometerAlt },
      { key: 'orderHistory', label: 'Order History', icon: FaHistory },
      { key: 'templeInfo', label: 'Temple Information', icon: FaPlaceOfWorship },
      //{ key: 'ticketManagement', label: 'Ticket Management', icon: FaTicketAlt },
      { key: 'services', label: 'Services', icon: FaClipboardList },
      { key: 'about', label: 'About', icon: FaInfoCircle },
    ],
    org: [
      { key: 'orgInfo', label: 'Organization Info', icon: FaBuilding },
      { key: 'eventHistory', label: 'Event History', icon: FaHistory },
    ],
  };

  // Get tabs based on the entity type
  const tabs = tabConfig[entityType] || [];

  return (
    <div className="bg-white shadow-lg border-r border-gray-300 h-full fixed top-0 left-0 w-64">
      <div className="text-2xl font-bold text-center py-8 bg-white">
        Admin Menu
      </div>
      <nav className="flex flex-col space-y-4 p-4">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`flex items-center w-full text-left px-2 py-3 text-1xl font-semibold transition-colors duration-300 ${
              currentTab === tab.key
                ? 'bg-gray-200 text-gray-900 border-l-4 border-indigo-500'
                : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
            }`}
            onClick={() => setCurrentTab(tab.key)}
          >
            <tab.icon className="mr-3" />
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default TabNavigation;
